import gql from "graphql-tag";
import {client} from "./client";
import {Authenticate} from "../../schema/authenticate";
import {FetchResult, Mutation} from "../../types";

const getAuthenticationMutation = (email: string, password: string): any => ({
    variables: {input: {email, password}},
    mutation: gql`${Authenticate}`
});

export async function authenticate (email: string, password: string, ) {
    const result: FetchResult<Mutation> = await client.mutate(getAuthenticationMutation(email, password));
    const jwtToken = result.data?.authenticate?.jwtToken;
    if (!jwtToken) {
        throw new Error('not authenticated');
    } else {
        return {jwtToken};
    }
}
